import React from 'react';
import Equivalencies from '../Equivalencies';
import Requirements from '../Requirements';
import './Results.scss';

const Results = (props) => (
    <section className="ghg-section ghg-results">
        <header className="ghg-header">
            <h2 className="ghg-header-two">
                Equivalency Results
                <span className="ghg-details">
                    <a href="https://www.epa.gov/greenpower/green-power-equivalency-calculator-calculations-and-references"
                       className="ghg-link" target="_blank">How are they calculated?</a>
                </span>
            </h2>
        </header>
        {/* <section className="ghg-print-container">
            <i className="fa fa-print" aria-hidden="true" onClick={(e) => props.onPrint()}>&nbsp;</i>
        </section> */}
        <section className="ghg-subsection ghg-grid-row">
            <fieldset className="ghg-fieldset ghg-grid-col ghg-grid-12">
                <span className="ghg-details"><strong>This amount of green power is enough to power:</strong></span>
            </fieldset>
            <Equivalencies/>
        </section>
        <section className="ghg-subsection ghg-grid-row ghg-no-border">
            <fieldset className="ghg-fieldset ghg-grid-col ghg-grid-12">
                <span className="ghg-details"><strong>To produce an equivalent amount of power would require:</strong></span>
            </fieldset>
            <Requirements/>
        </section>
    </section>
);

export default Results;


/** WEBPACK FOOTER **
 ** ./src/components/Results/Results.js
 **/